import { isBefore } from 'date-fns';
import isEqualTime from './isEqualTime';

const isSameOrBefore = (compareDate: Date, date: Date) => {
  return isBefore(compareDate, date) || isEqualTime(compareDate, date);
};

export default isSameOrBefore;
